import { render, staticRenderFns } from "./BiographySmartphoneView.vue?vue&type=template&id=6d3f543b&scoped=true&"
import script from "./BiographySmartphoneView.vue?vue&type=script&lang=js&"
export * from "./BiographySmartphoneView.vue?vue&type=script&lang=js&"
import style0 from "./BiographySmartphoneView.vue?vue&type=style&index=0&id=6d3f543b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f543b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VFadeTransition,VIcon,VImg,VSkeletonLoader,VSpacer})
